<template>
  <div>
    <div :style="{ backgroundImage: `url('${bannerImg}')` }" class="custom-header-wrapper responsive-banner">
      <!-- <base-header type="gradient-success" class="pb-6 pt-5 pt-md-8"> -->
      <base-header class="pb-6 pt-5 pt-md-8">
      
      </base-header>

   <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-md-4 col-12 d-flex">
        <a-spin :spinning="totalPointsLoading" class="w-100">
          <div class="spin-content w-100">
            <stats-card
              title="Current Available Points"
              :sub-title="totalPoints"
              type="gradient-info"
              class="mb-4 mb-xl-0 w-100"
              variant="white"
            >
            <template #footer>
              <div class="text-muted">
                As of {{ dateToday }}
              </div>
            </template>
            </stats-card>
          </div>
        </a-spin>
      </div>

      <div class="col-md-4 col-12 d-flex">
        <a-spin :spinning="totalPointsExpLoading" class="w-100">
          <div class="spin-content w-100">
            <stats-card
              title="Points to Expire"
              :sub-title="totalPointsExp"
              type="gradient-info"
              class="mb-4 mb-xl-0 w-100"
              variant="white"
            ></stats-card>
          </div>
        </a-spin>
      </div>

      <div class="col-md-4 col-12 d-flex">
        <a-spin :spinning="pointsExpLoading" class="w-100">
          <div class="spin-content w-100">
            <stats-card
              title="Points Expiration"
              :min-title="pointsExp"
              type="gradient-info"
              class="mb-4 mb-xl-0 w-100"
              variant="white"
            ></stats-card>
          </div>
        </a-spin>
      </div>
    </div>
  </div>


   </div>
   <div class = "mt-3">
    <div class="container-fluid row">
      <div class="col-12">
        <div class="row" v-if="clpSitePageSettings.allow_points_viewing">
          <div class="col-sm-6 col-12">
            <h5 class="card-title text-uppercase text-muted mb-3">
              Points History
            </h5>
          </div>
        </div>
        <div class="row mb-5" v-if="clpSitePageSettings.allow_points_viewing">
         <div class="col-md-4 col-12 d-flex">
            <a-spin :spinning="earnedThisMonthLoading" class="w-100">
              <div class="spin-content w-100">
                <stats-card
                  title="Earned This Month"
                  :sub-title="earnedThisMonth"
                  type="gradient-success"
                  icon="fa fa-plus"
                  class="mb-4 mb-xl-0 w-100"
                  variant="blue"
                >
                </stats-card></div
            ></a-spin>
          </div>
          <div class="col-md-4 col-12 d-flex">
            <a-spin :spinning="spentThisMonthLoading" class="w-100">
              <div class="spin-content w-100">
                <stats-card
                  title="Spent This Month"
                  :sub-title="spentThisMonth"
                  type="gradient-danger"
                  icon="fa fa-minus"
                  class="mb-4 mb-xl-0 w-100"
                  variant="blue"
                >
                </stats-card></div
            ></a-spin>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-12 d-flex">
            <h5 class="card-title text-uppercase text-muted mb-0">
              <!-- remove label -->
            </h5>
          </div>
          <div class="col-md-4 col-12 text-right">
            <router-link
              class="view-details-link"
              :to="{
                name: 'PointsHistory',
                params: { siteName: clpSitePageSettings.siteName }
              }"
              v-if="clpSitePageSettings.allow_trx_history_view"
            >
              View Details</router-link
            >
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-md-4 col-12 d-flex">
            <a-spin :spinning="lastPurchaseDateLoading" class="w-100">
              <div class="spin-content w-100">
                <stats-card
                  title="Last Purchase Date"
                  :min-title="lastPurchaseDate"
                  type="gradient-info"
                  icon="fa fa-calendar"
                  class="mb-4 mb-xl-0 w-100"
                  variant="blue"
                >
                </stats-card></div
            ></a-spin>
          </div>
          <div class="col-md-4 col-12 d-flex">
            <a-spin :spinning="totalPurchaseThisMonthLoading" class="w-100">
              <div class="spin-content w-100">
                <stats-card
                  title="Total Purchase This Month"
                  :min-title="totalPurchaseThisMonth"
                  type="gradient-warning"
                  icon="fa fa-receipt"
                  class="mb-4 mb-xl-0 w-100"
                  variant="blue"
                >
                </stats-card></div
            ></a-spin>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-12" v-if="clpSitePageSettings.display_site_text">
        <div class="row">
          <div class="col-12">
            <h5 class="card-title text-uppercase text-muted mb-0">
              Announcements!
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card mb-3">
              <div class="row no-gutters">
                <div class="col-md-12">
                  <div class="card shadow ">
                    <div class="card-header border-0">
                      <p>{{ clpSitePageSettings.site_text }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>
  </div>
</template>
<script>
import HTTPRequest from '../controllers/httpRequest';
import moment from 'moment-timezone';
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  name: 'Rewards',
  props: {
    clpSitePageSettings: Object,
    memberData: Object,
    sitePageTheme: Object
  },
  data() {
    return {
      totalPoints: 0,
      totalPointsLoading: false,
      earnedThisMonth: 0,
      earnedThisMonthLoading: false,
      spentThisMonth: 0,
      spentThisMonthLoading: false,
      lastPurchaseDate: '1970-01-01',
      lastPurchaseDateLoading: false,
      totalPurchaseThisMonth: 0,
      totalPurchaseThisMonthLoading: false,
      pointsExp: 'N/A',
      pointsExpLoading: false,
      totalPointsExp: 0,
      totalPointsExpLoading: false,
      dateToday: 'August 28, 2025'
    };
  },

  methods: {
    getTotalPoints: async function() {
      this.totalPointsLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=TOTAL_POINTS&member_id=${this.memberData.id}`
      );
      
      if (response.data && response.data.total_points != null) {
        this.totalPoints = response.data.total_points;
      } else {
        this.totalPoints = '0';
      }

      this.totalPointsLoading = false;
    },

    getEarnedThisMonth: async function() {
      this.earnedThisMonthLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=MONTHLY_POINTS_EARNED&member_id=${this.memberData.id}`
      );

      if (response.data && response.data.points != null) {
        this.earnedThisMonth = response.data.points;
      } else {
        this.earnedThisMonth = '0';
      }

      this.earnedThisMonthLoading = false;
    },

    getSpentThisMonth: async function() {
      this.spentThisMonthLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=MONTHLY_POINTS_SPENT&member_id=${this.memberData.id}`
      );

      if (response.data && response.data.points != null) {
        this.spentThisMonth = response.data.points;
      } else {
        this.spentThisMonth = '0';
      }

      this.spentThisMonthLoading = false;
    },

    getLastPurchaseDate: async function() {
      this.lastPurchaseDateLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=LAST_PURCHASE_DATE&member_id=${this.memberData.id}`
      );

      if (response.data && response.data.last_transaction_date != null) {
        this.lastPurchaseDate = moment(response.data.last_transaction_date).format(
          'MM/DD/YYYY'
        );
      } else {
        this.lastPurchaseDate = 'N/A';
      }
      console.log('lastPurchaseDatez', this.lastPurchaseDate)
      this.lastPurchaseDateLoading = false;
    },

    getTotalPurchaseThisMonth: async function() {
      this.totalPurchaseThisMonthLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=MONTHLY_PURCHASED&member_id=${this.memberData.id}`
      );

      if (response.data && response.data.purchase_amount != null) {
        this.totalPurchaseThisMonth = response.data.purchase_amount;
      } else {
        this.totalPurchaseThisMonth = '0';
      }

      this.totalPurchaseThisMonthLoading = false;
    },

    getPointsExpiration: async function() {
      this.pointsExpLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=POINTS_EXPIRATION&member_id=${this.memberData.id}`
      );

      if (response.data) {
        this.pointsExp = moment(response.data.expiry_date).tz(TIMEZONE).format('MMMM D, YYYY');
      } else {
        this.pointsExp = 'N/A';
      }

      this.pointsExpLoading = false;
      this.getPointsExpired(this.memberData.id, response.data.expiry_date)
    },

    getPointsExpired: async function(memberId, expiryDate) {
      this.totalPointsExpLoading = true;

      const response = await HTTPRequest.getRequest(
        `/api/v2/clp_members/rewards?q=POINTS_EXPIRED&member_id=${memberId}&expiry_date=${expiryDate}`
      );

      if (response.data != null) {
        this.totalPointsExp = response.data.total_points_expired;
      } else {
        this.totalPointsExp = '0';
      }

      this.totalPointsExpLoading = false;
    }
  },

  computed: {
    bannerImg: function () {
      const bannerPath = this.clpSitePageSettings.banner_image;
      if (!bannerPath || bannerPath === 'null' || bannerPath === '/null') {
        return require('../../images/banner_bg.jpg');
      }
      return '/' + bannerPath;
    },
    headerBackgroundStyle() {
      return {
        backgroundImage: `url('${this.bannerImg}')`,
      };
    }
  },

  created() {
    this.getTotalPoints();
    this.getEarnedThisMonth();
    this.getSpentThisMonth();
    this.getLastPurchaseDate();
    this.getTotalPurchaseThisMonth();
    this.getPointsExpiration();
  },
  mounted() {
    this.dateToday = moment().tz(TIMEZONE).format('MMMM D, YYYY');
  }
};
</script>

<style scoped>
.custom-header-wrapper {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 1rem;
  padding-bottom: 2rem;
  color: white;
 /* min-height: 200px; */
  height: 380px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-header-wrapper {
    background-position: top;
    min-height: 150px;
    padding-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .custom-header-wrapper {
    background-size: contain;
    padding-top: 0.5rem;
    padding-bottom: 1rem;
  }
}

.card-title {
  color: #003A90 !important;
  font-weight: 900;
}
.h5 {
  color: #003A90 !important;
  font-weight: bold;
}

.view-details-link {
  color: #003A90;
  font-weight: bold;
  text-decoration: none;
}
.view-details-link:hover {
  text-decoration: underline;
}

.text-muted {
  color: #003A90 !important;
}

</style>
